import i18next from "i18next";
import { initReactI18next } from "react-i18next";

const i18n = i18next;
const localStorageLanguage = localStorage.getItem("language") || "de";

i18n.use(initReactI18next).init({
  resources: {},
  lng: localStorageLanguage,
  fallbackLng: "en",
});

i18n.on("languageChanged", (language) => {
  localStorage.setItem("language", language);
});

export { i18n };
